import useSWRImmutable from 'swr/immutable'

import { useApis } from '../contexts/api-context'

type TrainingType = {
  id: number
  name: string
}

export const fetchTrainings = async (api: any): Promise<TrainingType[]> => {
  const res = await api.getTrainings()
  return res.data
}

const useTrainings = () => {
  const { api } = useApis()

  const { data } = useSWRImmutable('useTrainings', () => fetchTrainings(api))

  return { trainings: data }
}

export default useTrainings
